export default __webpack_public_path__ + "static/media/Gloves of Illuminant Conviction.85481285.jpg";